/**
 * AOS (Animate On Scroll) 初期化
 * 全ページで共通して使用
 * Lenisとの統合対応
 */

(function() {
    'use strict';

    function initAOS() {
        if (typeof AOS === 'undefined') {
            console.warn('AOS library is not loaded');
            return;
        }
        var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        AOS.init({
            duration: 800,
            easing: 'ease-out',
            once: true,
            mirror: false,
            anchorPlacement: 'top-bottom',
            offset: 50,
            delay: 0,
            disable: prefersReducedMotion
        });

        // Lenisが使用されている場合、LenisのスクロールイベントにAOSを連携
        if (window.lenis) {
            window.lenis.on('scroll', function() {
                AOS.refresh();
            });
        } else {
            // Lenisがまだ読み込まれていない場合、Lenisの準備完了を待つ
            window.addEventListener('lenis:ready', function(event) {
                var lenis = event.detail;
                if (lenis && typeof AOS !== 'undefined') {
                    lenis.on('scroll', function() {
                        AOS.refresh();
                    });
                }
            });
        }

        // 初期化後に再計算
        if (typeof AOS.refresh === 'function') {
            AOS.refresh();
        }

        // prefers-reduced-motion時は即時表示
        if (prefersReducedMotion) {
            document.querySelectorAll('[data-aos]').forEach(function(el) {
                el.classList.add('aos-animate');
            });
        }
    }

    // AOS読み込みを最大5秒リトライして待つ
    function waitForAOS() {
        var attempts = 0;
        var maxAttempts = 50; // 100ms x 50 = 5s
        var checkInterval = setInterval(function() {
            attempts++;
            if (typeof AOS !== 'undefined') {
                clearInterval(checkInterval);
                initAOS();
            } else if (attempts >= maxAttempts) {
                clearInterval(checkInterval);
                console.error('AOS library failed to load after 5 seconds');
            }
        }, 100);
    }

    // DOM準備後に開始
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', waitForAOS);
    } else {
        waitForAOS();
    }
})();

